import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import CompanyLinksEditModal from 'modules/dashboard/widgets/CompanyLinks/components/Modal/CompanyLinksEditModal'

const CompanyLinksEditPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const handleClose = () => {
    navigate(navigation.dashboard.fullPath())
  }

  const handleCancel = () => {
    handleClose()
  }

  return <CompanyLinksEditModal handleClose={handleClose} handleCancel={handleCancel} />
}

export default CompanyLinksEditPage
